// IdentifyService.ts

import {
  anonymousIdentify as segmentAnonymousIdentify,
  identify as segmentIdentify,
} from "@/analytics"
import { oneSignalIdentify } from "@/stores/oneSignal"
import { setFullStoryUser } from "@/hooks/fullStory"
import { type UserProfile } from "@/types/userTypes"
import { identifyWithLaunchDarkly } from "@/services/launchDarkly"
import { segment } from "@/analytics/client"
import { expoRegisterDevice } from "@/stores/expoPushNotifications"

/**
 * Identifies the user across multiple services (LaunchDarkly, Segment, FullStory, etc.)
 * @param userProfile - The user profile object containing details like ID, email, etc.
 */
const identifyUser = async (userProfile?: UserProfile | null) => {
  if (userProfile) {
    // Segment
    await segmentIdentify(userProfile)

    // FullStory
    setFullStoryUser(
      userProfile.id,
      `${userProfile.firstName} ${userProfile.lastName}`,
      userProfile.email
    )

    // Expo Notifications
    void expoRegisterDevice()

    // OneSignal
    oneSignalIdentify(userProfile)
  } else {
    // Anonymous identify
    await segmentAnonymousIdentify()

    const userInfo = segment?.userInfo?.get()
    if (userInfo) {
      setFullStoryUser(userInfo.anonymousId)
    }
  }

  // LaunchDarkly
  await identifyWithLaunchDarkly(userProfile)
}

export { identifyUser }
